import { render, staticRenderFns } from "./base-navigation-loader.vue?vue&type=template&id=bcb87fc0"
import script from "./base-navigation-loader.vue?vue&type=script&lang=js"
export * from "./base-navigation-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports